<template>
  <slot v-bind="{ success }"></slot>
</template>

<script>
import bcSelectedStore from '@/frontapp/store/bcSelected'
import { mapStores } from 'pinia'
import NetteAjax from "nette-base-module/js/nette/NetteAjax"

export default {
  computed: {
    ...mapStores(bcSelectedStore)
  },
  methods: {
    success() {
      this.bcSelectedStore.resetSelected()
      NetteAjax.ajax(this.$controls['table'].refresh)
    },
  }
}
</script>